/* RESPONSIBLE TEAM: team-messenger */

export const BACKGROUND_IMAGE_WIDTH = 400;
export const BACKGROUND_IMAGE_HEIGHT = 704;
